import { FC } from 'react';
import { WrapInLayout } from '../layouts';
import CouponList from '../components/coupons/CouponList';

const CouponsPage: FC = () => (
  <WrapInLayout title="Coupons / Discounts" layout="dashboard">
    <h1 className="text-xl font-semibold mb-3">Coupons / Discounts</h1>
    <CouponList />
  </WrapInLayout>
);

export default CouponsPage;
